
<template>
    <div class="import">
        <div class="import-left">
            <img class="icon" :src="icon" alt />
            <input
                :placeholder="placeholder"
                class="input-con"
                :type="type || 'text'"
                :value="value"
                @input="$emit('input',$event.target.value)"
            />
        </div>
        <div class="import-right">
            <!-- 定义左边信息内容 -->
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "import",
    props: ["value", "placeholder", "icon", "type"],
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.import {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dddddd;
    .import-left {
        display: flex;
        align-items: center;
        height: 40px;
        .icon {
            height: 19px;
            width: 14px;
        }
        .input-con {
            height: 30px;
            width: 220px;
            margin-left: 10px;
            font-size: 16px;
            margin-top: 5px;
            border: none;
            outline: none;
            &::-webkit-input-placeholder {
                color: #c7c6cd;
            }
        }
    }
    .import-right {
        margin-right: 10px;
        font-size: 20px;
    }
}
</style>